import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { _DateFormat } from '../../molecules';
export const DateMaturity = memo((props) => {
    return _jsx(_DateFormat, Object.assign({}, props, { format: "dd MMM yyyy", toUtc: true }));
});
